import React from "react";
import { colors } from "../theme";

const F = "'Montserrat',sans-serif";

/**
 * PageShell — the app layout container.
 *
 * A full-height flex row that holds the <Sidebar /> and the page content.
 * Owns the shared shell styling (height, font, content-area background, text
 * colour) so every page stays consistent and the whole body re-themes from a
 * single token (colors.surface.content).
 *
 * Usage:
 *   <PageShell>
 *     <Sidebar ... />
 *     <main> ...page content... </main>
 *   </PageShell>
 *
 * Pass `style` to extend/override for the rare page that needs it.
 */
export default function PageShell({ children, style }) {
  return (
    <div style={{
      display: "flex",
      height: "100vh",
      fontFamily: F,
      background: colors.surface.content,
      color: colors.text.heading,
      overflow: "hidden",
      ...style,
    }}>
      {children}
    </div>
  );
}
